import { Provider } from "src/types";

const KEY = "providerChannel"; // sessionStorage key

function mapChannelToProvider(channel?: string | null): Provider {
  return channel?.toLowerCase() === "bazar"
    ? "bazarpay"
    : channel?.toLowerCase() === "mayket"
      ? "mayket"
      : "pec";
}

export function providerFromUrl(): Provider {
  if (typeof window === "undefined") {
    return "pec";
  }

  const url = new URL(window.location.href);
  const queryChannel = url.searchParams.get("channel");
  const saved = sessionStorage.getItem(KEY);

  if (queryChannel) {
    const provider = mapChannelToProvider(queryChannel);
    sessionStorage.setItem(KEY, provider);
    return provider;
  }

  if (saved) {
    return saved as Provider;
  }

  const fallback = "pec" as Provider;
  sessionStorage.setItem(KEY, fallback);
  return fallback;
}

export function clearStoredProvider() {
  if (typeof window !== "undefined") {
    sessionStorage.removeItem(KEY);
  }
}
